module.exports = __webpack_public_path__ + "static/img/shezhi_gerenziliao.d979dd3d.png";